<template>
    <div
        v-if="notifications.length > 0"
        ref="notificationCards">
        <div
            v-if="label"
            class="nav-title">
            {{ label }}
        </div>
        <div
            v-for="(notification, index) in notifications"
            :key="notification.id"
            @keydown.up.prevent="handleArrowKeyNavigation($event, index)"
            @keydown.down.prevent="handleArrowKeyNavigation($event, index)">
            <comment-notification-card
                v-if="getNotificationType(notification) === 'comment'"
                v-bind="getCommonProps(notification)"
                @card-clicked="onCardClicked" />
            <request-notification-card
                v-else-if="getNotificationType(notification) === 'request'"
                v-bind="getCommonProps(notification)"
                :request-status="notification.displayHeadlineMessageTemplateData.requestStatus"
                :requested-permission="notification.displayHeadlineMessageTemplateData.requestAction"
                :requested-entity-type="notification.displayHeadlineMessageTemplateData.requestEntityType"
                :requested-entity-id="notification.displayHeadlineMessageTemplateData.requestEntityId"
                :request-id="notification.displayHeadlineMessageTemplateData.requestId"
                :entity-name="notification.displayHeadlineMessageTemplateData.entityName"
                @manage-access="onManageAccess"
                @card-clicked="onCardClicked" />
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import CommentNotificationCard from './comment-notification-card.vue';
import RequestNotificationCard from './request-notification-card.vue';
import { useArrowKeyNavigation } from '@/common/use/use-arrow-key-navigation/use-arrow-key-navigation';

export default {
    name: 'NotificationList',
    components: {
        CommentNotificationCard,
        RequestNotificationCard,
    },
    props: {
        notifications: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
    },
    emits: ['cardClicked', 'manage-access'],
    setup () {
        const notificationCards = ref(null);
        const { handleArrowKeyNavigation } = useArrowKeyNavigation({
            containerRef: notificationCards,
            selector: '.base-notification-card',
        });

        return {
            notificationCards,
            handleArrowKeyNavigation,
        };
    },
    methods: {
        getNotificationType (notification) {
            if (notification.displayHeadlineMessageTemplateData?.requestId) {
                return 'request';
            }

            if (notification.notificationSource === 'comment') {
                return 'comment';
            }

            return undefined;
        },
        getCommonProps (notification) {
            const user = {
                fullName: notification.actionUser.name,
                username: notification.actionUser.email,
            };

            return {
                id: notification.id,
                user,
                header: notification.displayHeadlineMessage,
                body: notification.displayBodyMessage,
                timeStamp: notification.formattedTimestamp,
                unread: notification.isUnread,
            };
        },
        onCardClicked (id) {
            this.$emit('cardClicked', id);
        },
        onManageAccess (data) {
            this.$emit('manage-access', data);
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';

.nav-title {
    margin-top: 20px;
    margin-bottom: 8px;
}
</style>
